// Provider de TanStack Query + DensityProvider del tema. Defaults sensatos
// para el MVP.

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { useState, type ReactNode } from 'react';
import { AuthExpiredError } from '../lib/api/client';
import { DensityProvider } from '../lib/theme/density';

export function QueryProvider({ children }: { children: ReactNode }) {
  const [client] = useState(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: {
            // Si el token expiró, no reintentar — el ProtectedRoute redirige
            // a /login cuando el AuthProvider detecte signed_out.
            retry: (failureCount, error) => {
              if (error instanceof AuthExpiredError) return false;
              return failureCount < 1;
            },
            refetchOnWindowFocus: false,
          },
          mutations: {
            retry: false,
          },
        },
      }),
  );

  return (
    <QueryClientProvider client={client}>
      <DensityProvider>{children}</DensityProvider>
    </QueryClientProvider>
  );
}
